<template>
  <a-flex class="full-group-list" justify="space-between" align="center">
    <a-flex vertical class="list">
      <a-flex class="item" gap="small" align="center">
        <nut-avatar-group size="3">
          <nut-avatar size="23">
            <img :src="defaultHeaderImg" alt=""/>
          </nut-avatar>
          <nut-avatar size="23">
            <img :src="defaultHeaderImg" alt=""/>
          </nut-avatar>
          <nut-avatar size="23">
            <img :src="defaultHeaderImg" alt=""/>
          </nut-avatar>
        </nut-avatar-group>
        <text>恭喜 张三、李四... 满团啦！</text>
      </a-flex>
      <a-flex class="item" gap="small" align="center">
        <nut-avatar-group size="3">
          <nut-avatar size="23">
            <img :src="defaultHeaderImg" alt=""/>
          </nut-avatar>
          <nut-avatar size="23">
            <img :src="defaultHeaderImg" alt=""/>
          </nut-avatar>
          <nut-avatar size="23">
            <img :src="defaultHeaderImg" alt=""/>
          </nut-avatar>
        </nut-avatar-group>
        <text>恭喜 张三、李四... 满团啦！</text>
      </a-flex>
      <a-flex class="item" gap="small" align="center">
        <nut-avatar-group size="3">
          <nut-avatar size="23">
            <img :src="defaultHeaderImg" alt=""/>
          </nut-avatar>
          <nut-avatar size="23">
            <img :src="defaultHeaderImg" alt=""/>
          </nut-avatar>
          <nut-avatar size="23">
            <img :src="defaultHeaderImg" alt=""/>
          </nut-avatar>
        </nut-avatar-group>
        <text>恭喜 张三、李四... 满团啦！</text>
      </a-flex>
    </a-flex>
    <a-flex align="center" class="more">查看满团榜
      <right/>
    </a-flex>
  </a-flex>
</template>

<script setup lang="ts">
import {Right} from "@nutui/icons-vue";
import {defaultHeaderImg} from "@/lib/util";
</script>

<style scoped lang="sass">
.full-group-list
  height: 50px
  margin: 16px -10px -10px -10px
  background-color: #feeaea
  padding: 0 12px
  overflow: hidden
  border-radius: 0 0 10px 10px

  > .list
    > .item
      height: 50px
      color: #222222
      font-size: 12px
      animation: ani-scroll 3s infinite

  > .more
    color: red
    font-size: 12px

    > .nut-icon
      width: 10px
      height: 10px

@keyframes ani-scroll
  0%
    transform: translateY(0)
  10%
    transform: translateY(-100%)
  100%
    transform: translateY(-100%)
</style>